import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { CampaignReference } from "./useCampaignDailySetup";
export type ConfiguredActionSummary = {
  dispatch?: { enabled: boolean; reason: string };
  action_id: string; origin: "routine" | "campaign_plan" | "dataset_query" | "source_analytics" | "standalone"; brand_id: string; title: string; task_slug: string;
  campaign_id: string | null; source: { assignment_id: string; capability: string } | null; query_id: string | null;
  schedule: { id: string; status: "active" | "paused"; cron_expression: string; timezone: string;
    next_fire_at: string | null; last_fired_at: string | null } | null;
};
export function useConfiguredActions(brandId: string) {
  return useQuery({ queryKey: ["configured-actions", brandId], enabled: !!brandId, retry: false,
    queryFn: async () => {
      const result = await api.get<{ data: { brand_id: string; actions: ConfiguredActionSummary[] } }>(`/api/v1/brands/${encodeURIComponent(brandId)}/configured-actions`);
      if (result.data.brand_id !== brandId || result.data.actions.some(action => action.brand_id !== brandId)) throw new Error("Action inventory belongs to another brand.");
      return result.data;
    } });
}
export function useConfiguredActionCatalog(brandId: string) {
  const inventory = useConfiguredActions(brandId);
  const choices: CampaignReference[] = (inventory.data?.actions ?? []).map(action => ({
    kind: "configured_action", action_id: action.action_id, origin: action.origin, label: action.title,
  }));
  return { choices, datasetCatalogAtLimit: false, loading: inventory.isLoading, error: inventory.error,
    reload: async () => (await inventory.refetch()).isSuccess };
}
